import { Box, Grid, Typography } from "@mui/material";

interface ITextCard {
    title: string;
    description: {
        firstColumnText: string | number;
        secondColumnText: string | number;
    }[]
}
const TextCard = ({ description, title }: ITextCard) => {
    return (
        <Box >
            <Typography sx={{ fontSize: "0.875rem !important", color: "var(--tirnary-text-color)", marginBottom: "10px" }} >{title}</Typography>
            <Grid container sx={{ flexDirection: "column", gap: "10px", justifyContent: "center" }}>
                {description?.map((text, index) => (
                    <Box key={index} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "0.875rem !important", color: "var(--tirnary-text-color)" }}>{text.firstColumnText}</Typography>
                        <Typography sx={{ fontSize: "0.875rem !important", color: "var(--tirnary-text-color)" }}>{text.secondColumnText}</Typography>
                    </Box>
                ))}
            </Grid>
        </Box>
    )
}

export default TextCard